import { Link } from '@tanstack/react-router'

import type { ButtonProps } from '@/components/ui'
import { isCreditsPlan, useAccount } from '@/modules/account'
import { useProject } from '@/modules/projects'

interface ProcessButtonProps extends ButtonProps {
  isBlocked?: boolean
  validationBehaviour: 'message' | 'hidden' | 'disable-only'
}

export const CreditsMessage = ({
  isBlocked,
  validationBehaviour,
}: ProcessButtonProps) => {
  const project = useProject()
  const account = useAccount()

  if (!isBlocked) return
  if (validationBehaviour !== 'message') return
  if (!isCreditsPlan(account?.planKind)) return
  if (project?.expired) return

  return (
    <span className="text-muted-foreground flex items-center gap-1 text-xs flex-wrap">
      Statements exceeds available credits.
      <Link
        to="/credits"
        preload="intent"
        className="text-brand underline cursor-pointer"
      >
        Buy more credits
      </Link>
    </span>
  )
}
